var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-menu',{attrs:{"offset-y":"","open-on-hover":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"outlined":"","color":"black","dark":""}},'v-btn',attrs,false),on),[_vm._v(" Sort By : "+_vm._s(_vm.filterInput.sortBy)+" "),_c('span',[_c('v-icon',[_vm._v(" mdi-chevron-down ")])],1)])]}}])},[_c('sorting-options')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }